import { Label } from '@cian/ui-kit';
import { IconFinanceArrowBoldDown16, IconFinanceArrowBoldUp16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import * as styles from './styles.css';

import { IPriceCellValue } from '../../../../../../../types/newbuildingsCompare';
import leadingImage from '../assets/LeadingImage.svg';

export interface IPriceCellMobileProps {
  data: IPriceCellValue;
}

export const PriceCellBadge = ({ data }: IPriceCellMobileProps): React.JSX.Element => {
  let icon: React.JSX.Element;

  switch (data.trend) {
    case 'increase':
      icon = <IconFinanceArrowBoldUp16 color="icon-primary-default" />;
      break;
    case 'decrease':
      icon = <IconFinanceArrowBoldDown16 color="icon-primary-default" />;
      break;
    case 'noChange':
      icon = <img alt="" src={leadingImage} />;
      break;
  }

  return (
    <Label
      data-testid="price-cell-mobile"
      icon={icon}
      color="text-primary-default"
      background="surface-neutral-default"
      bold={true}
      className={styles['label']}
    >
      {data.value}
    </Label>
  );
};
